<template>
  <a-layout-footer id="footer">
    <div class="row container">
      <div class="group item">
        <img src="@/assets/logo-wheezo-vert.svg" class="h-16 xs:mb-6" />
      </div>
      <div class="group">
        <div class="item">
          <a href="mailto:support@wheezo.com">
            Contact Us
          </a>
        </div>
        <div class="item">
          <a href="http://wheezo.com/share/privacy" target="_blank">
            Privacy Policy
          </a>
        </div>
        <div class="item">
          <a href="http://wheezo.com/share/terms" target="_blank">
            Terms and Conditions
          </a>
        </div>
      </div>
    </div>
  </a-layout-footer>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {}
</script>
<style lang="postcss" scoped>
#footer {
  @apply bg-white p-0;
  border-top: 1px solid #e8e8e8;
  & .row {
    @apply flex flex-wrap items-center justify-between text-center my-12;
  }
}
@screen xs {
  #footer {
    & .row {
      & .group {
        @apply w-full;
      }
      & .item {
        @apply mb-6;
      }
    }
  }
}
@screen md {
  #footer {
    & .row {
      & .group {
        @apply flex w-1/3 justify-between;
        & .item {
          @apply mr-4;
        }
      }
    }
  }
}
</style>
